"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.initCybertronics = void 0;
var _utils_1 = require("../_utils");
var methods_to_call_1 = require("../_utils/methods-to-call");
var call_window_cybertronics_1 = require("./call-window-cybertronics");
var settingsByEnv = {
    prod: {
        proxyAddress: "https://seller-cbr.wildberries.ru",
        team: "wildberries",
    },
    stage: {
        proxyAddress: "https://seller-cbr.wildberries.ru",
        team: "wildberries_test",
    },
    dev: {
        proxyAddress: "https://seller-cbr.wildberries.ru/external-api-seller-services",
        team: "wildberries_test",
    },
};
var initCybertronics = function (env) {
    (0, _utils_1.registerScript)({
        src: "https://static-basket-02.wbbasket.ru/vol20/sec/0.0.1/cybertronica/v4.9.1.js",
        onLoad: function () {
            (0, call_window_cybertronics_1.callWindowCybertronics)(function () {
                var _a;
                console.log("call window.AFCYBERTONICA.init");
                (_a = window.AFCYBERTONICA) === null || _a === void 0 ? void 0 : _a.init(settingsByEnv[env] || settingsByEnv["prod"]);
            });
            if (methods_to_call_1.cybertronicsMethods.methodsToCall.length > 0) {
                console.log("process delayed calls to window.AFCYBERTONICA");
                methods_to_call_1.cybertronicsMethods.methodsToCall.forEach(function (m) {
                    m();
                });
            }
        },
    });
};
exports.initCybertronics = initCybertronics;
//# sourceMappingURL=init-cybertronics.js.map